import { Timestamp } from '@britishcouncil/common-core';
import { api, OdpAssessmentReportRecordDto, PagedResultOfOdpAssessmentReportRecordDto } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { OdpAssessmentReportFilterType } from './odpAssessmentReportTypes';
import { getPaginationParameters, getQueryStringParameters } from 'utils';

type ReportParams = TableState<OdpAssessmentReportRecordDto, OdpAssessmentReportFilterType>;

const mapQueryParams = (params: ReportParams) => {
  if (params.filters.date?.[0] == undefined || params.filters.date[1] == undefined) {
    throw new Error('From and To dates are required');
  }

  return {
    ...getPaginationParameters(params),
    filter: {
      from: Timestamp.toISOString(params.filters.date[0]),
      to: Timestamp.toISOString(params.filters.date[1]),
      examinerNumber: params.filters.examinerNumber ?? '',
      completed: params.filters.completed ?? null,
      showDeleted: params.filters.showDeleted ?? false,
    },
  };
};

export const odpAssessmentReportApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getOdpAssessmentReportRecords: builder.query<
      PagedResultOfOdpAssessmentReportRecordDto,
      ReportParams
    >({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.odpAssessmentReport.getOdpAssessmentReport(input);
      },
      providesTags: ['OdpAssessment'],
    }),
    generateOdpAssessmentReportPdfReport: builder.mutation<File, ReportParams>({
      query: async (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.odpAssessmentReport.getOdpAssessmentPdfReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
    generateOdpAssessmentReportExcelReport: builder.mutation<File, ReportParams>({
      query: (params) => {
        const input = getQueryStringParameters(mapQueryParams(params));
        return api.odpAssessmentReport.getOdpAssessmentExcelReport(input, {
          format: 'arraybuffer',
        });
      },
    }),
  }),
});

export const {
  useGetOdpAssessmentReportRecordsQuery,
  useGenerateOdpAssessmentReportPdfReportMutation,
  useGenerateOdpAssessmentReportExcelReportMutation,
} = odpAssessmentReportApi;
